interface ReplaceStringVarsProps {
  text: string
  vars?: string[]
}

export function replaceStringVars({ text, vars = [] }: ReplaceStringVarsProps) {
  return vars.reduce((accumulator, current, index) => {
    return accumulator.replaceAll(`$${index}`, current)
  }, text)
}
